import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";

function HamburgerMenu() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box>
      {/* メニューボタン */}
      <Button variant="outline" onClick={onOpen}>
        <HamburgerIcon />
      </Button>

      {/* ドロワーメニュー */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay>
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>メニュー</DrawerHeader>

            <DrawerBody>
              {/* ここにメニューの内容を追加 */}
              <p>会社紹介</p>
              <p>製品紹介</p>
              <p>社長メッセージ</p>
              <p>採用窓口</p>
              <p>社員インタビュー</p>
            </DrawerBody>

            <DrawerFooter>
              {/* 必要に応じてフッター項目を追加 */}
              <Button variant="outline" mr={3} onClick={onClose}>
                キャンセル
              </Button>
            </DrawerFooter>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </Box>
  );
}

export default HamburgerMenu;
